import ApiService from '@/common/api.service'
import * as utils from '@/common/utils'

const module = 'admin/accountTypesModule'

function defaults () {
  return {
    id: null,
    name: '',
    description: '',
    access_level: {
      level: 7,
      name: ''
    },
    permissions: {},
    product_code: '',
    created_at: '',
    updated_at: ''
  }
}

function formDefaults () {
  return {
    access_levels: [],
    permissions: {}
  }
}

function transformPost (data) {
  let post_permissions = {}

  let permission_keys = Object.keys(data.permissions)
  permission_keys.forEach((permission_key) => {
    post_permissions[permission_key] = {}
  })

  permission_keys.forEach((permission_key) => {
    let action_keys = Object.keys(data.permissions[permission_key].actions)
    action_keys.forEach((action_key) => {
      post_permissions[permission_key][action_key] =
        data.permissions[permission_key].actions[action_key].allow
    })
  })

  let result = Object.assign({}, data)
  result.permissions = post_permissions
  result.access_level = data.access_level.level
  result.name = utils.trimmify(data.name)
  result.description = utils.trimmify(data.description)
  result.product_code = utils.trimmify(data.product_code)

  return result
}

export const state = {
  data: Object.assign({}, defaults()),
  form: Object.assign({}, formDefaults())
}

export const getters = {
  get (state) {
    return state.data
  },

  getForm (state) {
    return state.form
  }
}

export const actions = {
  fetch (context, id) {
    return ApiService
      .get(`account-types/${id}`)
      .then((response) => {
        context.commit('set', response.data.data)
        return response
      })
  },

  fetchFormCreate (context) {
    return ApiService
      .get(`account-types/create`)
      .then((response) => {
        context.commit('setFormData', response.data.data)
        let accountType = defaults()
        accountType.permissions = response.data.data.permissions
        context.commit('set', accountType)
        return response
      })
  },

  fetchFormEdit (context, id) {
    return ApiService
      .get(`account-types/${id}/edit/`)
      .then((response) => {
        context.commit('setFormData', response.data.data)
        context.commit('set', response.data.data)
        return response
      })
  },

  post (context, { data, params }) {
    return ApiService
      .post(`account-types`, {
        data: transformPost(context.getters['get']), params
      })
      .then((response) => {
        context.commit('set', response.data.data)
        utils.addRecentHistory(module, response.data.data)
        return response
      })
  },

  put (context, { data, params }) {
    let id = context.getters['get'].id
    return ApiService
      .put(`account-types/${id}`, {
        data: transformPost(context.getters['get']), params
      })
      .then((response) => {
        return response
      })
  },

  delete (context) {
    let id = context.getters['get'].id
    return ApiService
      .delete(`account-types/${id}`)
      .then((response) => {
        return response
      })
  },

  query (context, params) {
    return ApiService
      .get(`account-types`, params)
      .then((response) => {
        return response
      })
  }
}

export const mutations = {
  set (state, data) {
    state.data = {
      id: data.id,
      name: data.name,
      description: data.description,
      access_level: data.access_level,
      permissions: data.permissions,
      product_code: data.product_code,
      created_at: data.created_at,
      updated_at: data.updated_at
    }
  },

  setProp (state, property) {
    utils.mutateProp(state.data, property.name, property.value)
  },

  setProps (state, properties) {
    properties.forEach((property) => {
      utils.mutateProp(state.data, property.name, property.value)
    })
  },

  setFormData (state, data) {
    state.form = {
      permissions: data.permissions,
      access_levels: data.access_levels
    }
  },

  reset (state) {
    let accountType = defaults()
    accountType.permissions = state.form.permissions
    state.data = accountType
  },

  resetForm (state) {
    state.form = formDefaults()
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/administration/accountTypes/accountTypesModule.js